// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import './Spinner.css';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  display?: 'inline' | 'block';
  text?: string;
  className?: string;
}

export function Spinner({
  size = 'md',
  display = 'block',
  text,
  className = '',
}: SpinnerProps) {
  const classes = [
    'fin-spinner',
    `fin-spinner--${size}`,
    `fin-spinner--${display}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} role="status">
      <div className="fin-spinner__circle" />
      {text && <span className="fin-spinner__text">{text}</span>}
      <span className="fin-spinner__sr-only">Loading</span>
    </div>
  );
}
